import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import Base from '../js/base';
import Utils from '../js/utils';
import moment from 'moment';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7;
  var page_name = 'huyhieu-transaction';
  var pn = "div[data-name=\"".concat(page_name, "\"]");
  var page = 0;
  var limit = 5;

  var makerow = function makerow(rows) {
    var groupName = '';
    var representName = '';
    var receivers = rows.map(function (row) {
      return Base.initdata.emps.find(function (emp) {
        return emp.id === row.id_receiver;
      })['name'];
    }).join(', ');
    var row = rows[0];
    var sender = Base.initdata.emps.find(function (emp) {
      return emp.id === row.id_sender;
    });
    var $row = $("\n      <div class=\"block thanks-row\">\n        <div class=\"row\">\n          <div><span class=\"text-color-orange text-bold-only\">".concat(sender.name, "</span> t\u1EB7ng <span class=\"text-color-white\">").concat(row.qty, "</span> \u0111i\u1EC3m:</div>\n          <div class=\"text-align-right text-smaller\">").concat(moment(row.created_at).format(Base.dateTimeFormat), "</div>\n        </div>\n        <div class=\"recipients\">\n          ").concat(receivers, "\n        </div>\n        <div class=\"thanks-message padding-left\">\n          ").concat(row.message.replace(/\n/g, "<br />"), "\n        </div>\n        \n      </div>\n    "));
    return $row;
  };

  var get = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var $list, $loadmore, loading, rs, groupedRows, ts, totalItems, totalLoaded;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $list = $(pn + ' .thanks-list');
              $loadmore = $(pn + ' .loadmore');
              loading = $f7.dialog.preloader();
              _context.next = 5;
              return Base.api('Huyhieu', 'getTransaction', {
                page: page,
                limit: limit
              });

            case 5:
              rs = _context.sent;
              loading.close(); //Gộp các lần tặng theo transaction time

              groupedRows = {};
              rs.rows.forEach(function (row) {
                if (groupedRows[row.transaction_ts] === undefined) {
                  groupedRows[row.transaction_ts] = [row];
                } else {
                  groupedRows[row.transaction_ts].push(row);
                }
              });

              for (ts in groupedRows) {
                $list.append(makerow(groupedRows[ts]));
              }

              totalItems = Utils.str2Num(rs.total);
              totalLoaded = $list.find('.thanks-row').length;

              if (totalLoaded < totalItems) {
                $loadmore.parent().removeClass('display-none');
              } else {
                $loadmore.parent().addClass('display-none');
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function get() {
      return _ref2.apply(this, arguments);
    };
  }();

  var loadmore = function loadmore() {
    page += 1;
    get();
  };

  $update(function () {
    //DOM ready
    get();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">
  <div class="page-content">
    <div class="thanks-list margin-narrow">
    </div>
    <div class="block display-none">
      <a class="button loadmore" @click=${loadmore}>Xem tiếp</a>
    </div>
  </div>
</div>
`
    }
    ;
});